import { render, staticRenderFns } from "./editSku.vue?vue&type=template&id=5121302c&scoped=true"
import script from "./editSku.vue?vue&type=script&lang=js"
export * from "./editSku.vue?vue&type=script&lang=js"
import style0 from "./editSku.vue?vue&type=style&index=0&id=5121302c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5121302c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5121302c')) {
      api.createRecord('5121302c', component.options)
    } else {
      api.reload('5121302c', component.options)
    }
    module.hot.accept("./editSku.vue?vue&type=template&id=5121302c&scoped=true", function () {
      api.rerender('5121302c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wareProduct/editSku.vue"
export default component.exports